import * as Plugin from './Plugin';
import Vue from 'vue';
import Vuex from 'vuex';
import authentication from './Module/Authentication';
import global from './Module/Global';
import location from './Module/Location';
import pad from './Module/Pad';
import persist from './Persist';
import settings from './Module/Settings';
import subscription from './Module/Subscription';
import userGuidance from './Module/UserGuidance';
import versionHistory from './Module/VersionHistory';

// Attach Vuex
// -----------------------------------------------------------------------------

Vue.use(Vuex);

// Setup Store
// -----------------------------------------------------------------------------

const store = new Vuex.Store<any>({
	modules: {
		authentication,
		global,
		location,
		pad,
		settings,
		subscription,
		userGuidance,
		versionHistory,
	},
	plugins: [persist, Plugin.Example],
});

export default store;
